'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryOnError = exports.logoutOnMissingPortalId = exports.logoutOnUnauthorized = exports.logoutOn = exports.logoutOnError = exports.timeoutInQuery = exports.setRequest = exports.maybeUseIframeRequest = exports.hubapi = exports.lab = exports.defaults = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _params = require('../helpers/params');

var params = _interopRequireWildcard(_params);

var _url = require('../helpers/url');

var _core = require('./core');

var _response = require('../helpers/response');

var _location = require('../helpers/location');

var _authCache = require('../helpers/authCache');

var _authCache2 = _interopRequireDefault(_authCache);

var _promise = require('../helpers/promise');

var _update = require('../helpers/update');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaults = exports.defaults = function defaults(options) {
  return Object.assign({}, {
    timeout: 14000,
    withCredentials: true,
    portalId: window.hubspot && window.hubspot.portal && window.hubspot.portal.id,
    labs: window.hubspot && window.hubspot['__hub-http-labs']
  }, options);
};

var labEnabled = function labEnabled(labKey, options) {
  var localStorageKey = 'HUB-HTTP-LABS:' + labKey;
  var labOverride = options.localStorage && options.localStorage.getItem(localStorageKey);
  if (labOverride && labOverride.toLowerCase() === 'true') {
    // eslint-disable-next-line no-console
    console.log('Using localStorage override for ' + localStorageKey + ': ' + labOverride);
    return labOverride.toLowerCase() === 'true';
  }

  return _typeof(options.labs) === 'object' && options.labs[labKey];
};

var lab = exports.lab = function lab(labKey, middleware) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (o) {
    return o;
  };
  return function (options) {
    return labEnabled(labKey, options) ? middleware(options) : fallback(options);
  };
};

var hubapi = exports.hubapi = lab('HUBAPIDOTCOM', (0, _core.environmentUrl)((0, _core.standardApi)('api', 'hubapi')), (0, _core.environmentUrl)((0, _core.standardApi)('api', 'hubspot')));

var maybeUseIframeRequest = exports.maybeUseIframeRequest = function maybeUseIframeRequest(options) {
  var _parseUrl = (0, _url.parseUrl)(options.url),
      hostname = _parseUrl.hostname;

  var useIframeRequest = hostname.indexOf('api.hubspot') === 0;

  return (0, _update.set)('useIframeRequest', useIframeRequest)(options);
};

var setRequest = exports.setRequest = maybeUseIframeRequest;

var timeoutInQuery = exports.timeoutInQuery = function timeoutInQuery(options) {
  return typeof options.timeout === 'number' ? (0, _core.query)({ clienttimeout: options.timeout })(options) : options;
};

var buildLogoutUrl = function buildLogoutUrl(options) {
  var hostname = (0, _core.resolveApi)((0, _core.standardApi)('app', 'hubspot'));
  var loginDescriptor = {
    hostname: hostname,
    path: '/login/'
  };

  var loginQuery = { loginRedirectUrl: options.location.href };

  if (options.portalId) {
    loginQuery.loginPortalId = options.portalId;
  }

  loginDescriptor.query = params.stringify(loginQuery);

  return (0, _url.buildUrl)(loginDescriptor);
};

var onRedirectToLogin = function onRedirectToLogin(options) {
  return _authCache2.default.clear(options);
};

var handleLogoutFromRequest = function handleLogoutFromRequest(options) {
  var redirectUrl = buildLogoutUrl(options);
  if ((0, _location.redirectTo)(redirectUrl, options, onRedirectToLogin)) {
    throw new Error('Aborting: redirection in progress');
  }

  return options;
};

var handleLogoutFromResponse = function handleLogoutFromResponse(response) {
  var options = response.options;
  var redirectUrl = buildLogoutUrl(options);

  (0, _location.redirectTo)(redirectUrl, options, onRedirectToLogin);
  return _promise.Promise.reject((0, _response.responseError)(response, 'Aborting: redirection in progress'));
};

var logoutOnError = exports.logoutOnError = (0, _core.onResponseError)(handleLogoutFromResponse);

var logoutOn = exports.logoutOn = function logoutOn(predicate) {
  return function (options) {
    return (0, _core.onResponse)(function (response) {
      if (predicate(response)) {
        return handleLogoutFromResponse(response);
      }

      return response;
    })(options);
  };
};

var logoutOnUnauthorized = exports.logoutOnUnauthorized = logoutOn(function (response) {
  return response.status === 401;
});

var logoutOnMissingPortalId = exports.logoutOnMissingPortalId = function logoutOnMissingPortalId(options) {
  if (!options.portalId) {
    // eslint-disable-next-line no-console
    console.log('[hub-http] Could not find portal id. Redirecting');
    return handleLogoutFromRequest(options);
  }

  return options;
};

var retryOnError = exports.retryOnError = (0, _core.retry)(function (response) {
  return response.options.method === 'GET' && (response.status >= 500 || response.status === 0 && response.errorCode === 'NETWORKERROR');
}, {
  reason: 'Server error'
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.176/js/middlewares/hubapi.js
// module id = 53
// module chunks = 0